import React from 'react';
import Layout from '../../layout';






function Portfolio() {
  return (
   <Layout>
             <section class="page-header padding">
           <div class="overlay"></div>
            <div class="container">
               <div class="section-heading mt-40 text-center">
                    <h4 class="sub-heading">Our Projects</h4>
                    <h2>Transforming The Ideas<br/>And Visions For Industries!</h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
            </div>
        </section>

        <section class="project-section padding">
            <div class="container">
               <div class="row">
                   <div class="col-lg-12">
                       <ul class="project-filter text-center">
                            <li class="active" data-filter="*">All Projects</li>
                            <li data-filter=".architecture ">Architecture</li>
                            <li data-filter=".building">Building</li>
                            <li data-filter=".construction">Construction</li>
                            <li data-filter=".industrial">Industrial</li>
                        </ul>
                   </div>
               </div>
                <div class="project-items grid dl-lb-gallery row">
                    <div class="col-lg-3 col-md-6 padding-15 single-item architecture building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576545/derma/hcr8rnyfajohx6uwt5is.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700576545/derma/hcr8rnyfajohx6uwt5is.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="/project-details" class="cat">Architecture</a>
                                <h3><a href="project-details">The Burj Khalifa</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 padding-15 single-item construction building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576546/derma/kpc5rxkpoveveqxabwbo.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700576546/derma/kpc5rxkpoveveqxabwbo.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="/project-details" class="cat">Construction</a>
                                <h3><a href="project-details">Shun Hing Square</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 padding-15 single-item construction architecture">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576545/derma/tdbn3kvxp4mmpxeqf5jj.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700576545/derma/tdbn3kvxp4mmpxeqf5jj.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="/project-details" class="cat">Building</a>
                                <h3><a href="project-details">World Trade Center</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 padding-15 single-item architecture building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576542/derma/vmfmxxrg0oq7riekyre9.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700576542/derma/vmfmxxrg0oq7riekyre9.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="/project-details" class="cat">Industries</a>
                                <h3><a href="project-details">Mercury City Tower</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 padding-15 single-item construction industrial">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576542/derma/yo2doom5xwxfgqtzrzcn.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700576542/derma/yo2doom5xwxfgqtzrzcn.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="/project-details" class="cat">Building</a>
                                <h3><a href="project-details">Central Park Tower</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 padding-15 single-item industrial building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576544/derma/gd80e6v2hthtrcny4nuj.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700576544/derma/gd80e6v2hthtrcny4nuj.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="/project-details" class="cat">Construction</a>
                                <h3><a href="project-details">Vincom Landmark 81</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 padding-15 single-item industrial building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576544/derma/t4zveqfa6p3jjywe3bk9.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700576544/derma/t4zveqfa6p3jjywe3bk9.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="/project-details" class="cat">Building</a>
                                <h3><a href="project-details">The Exchange 106</a></h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 padding-15 single-item industrial building">
                        <div class="project-item">
                            <div class="project-thumb">
                               <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700576545/derma/raxfzer0ebwzqo6kjtxx.png" alt="project"/>
                                   <div class="project-view">
                                    <a class="dl-lightbox" href="https://res.cloudinary.com/dedfrilse/image/upload/v1700576545/derma/raxfzer0ebwzqo6kjtxx.png"><i class="fas fa-plus"></i></a>
                                </div>
                            </div>
                            <div class="project-content">
                                <a href="/project-details" class="cat">Architecture</a>
                                <h3><a href="project-details">The Burj Khalifa</a></h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* <section class="cta-section padding">
           <div class="overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 offset-lg-3">
                        <div class="cta-content text-center">
                            <div class="section-heading text-center">
                                <h4 class="sub-heading">Contact Us</h4>
                                <h2>Trusted By More Than 650,000 <br/>Happy<span> Peoples!</span></h2>
                                <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                            </div>
                            <a href="#" class="default-btn">Get a free quote <span></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}

        <div class="sponsor-section">
            <div class="container">
                <div class="slider sponsor-carousel nav-style">
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-6.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-3.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                </div>
            </div>
        </div> 
   </Layout>
  );
}

export default Portfolio;